import { createFileRoute } from '@tanstack/react-router';
import TerminalCreateView from '../terminal/ManageTerminalsView/components/TerminalCreateView';
export const Route = createFileRoute('/terminals/locations/create')({
  component: TerminalCreateView,
});
